var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styleObj)},[(_vm.data)?_c('e-charts',{style:(_vm.styleObj),attrs:{"autoresize":"","option":_vm.option,"theme":"theme-color","auto-resize":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }